import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "@/routes/rootRoute";

// Contenedor transparente (sin component: renderiza solo el Outlet del hijo).
// Agrupa listado y detalle de planta bajo `/plants` y aporta el primer crumb
// ("Plantas"), del que cuelga toda la jerarquía de migas.
export const plantsRoute = createRoute({
  path: "/plants",
  getParentRoute: () => rootRoute,
  staticData: { crumb: "plants" },
});

export const plantsIndexRoute = createRoute({
  path: "/",
  getParentRoute: () => plantsRoute,
  component: lazyRouteComponent(async () => {
    const m = await import("./Plants");
    return { default: m.Plants };
  }),
});
